module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', {
    class: _vm.numberClass
  }, [_vm._v("\n\t" + _vm._s(_vm.displayNumber.toLocaleString()) + "\n\t"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.threshold >= 0 && _vm.number >= _vm.threshold),
      expression: "threshold >= 0 && number >= threshold"
    }],
    staticClass: "fas fa-long-arrow-alt-up"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.threshold >= 0 && _vm.number < _vm.threshold),
      expression: "threshold >= 0 && number < threshold"
    }],
    staticClass: "fas fa-long-arrow-alt-down"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goalReached),
      expression: "goalReached"
    }],
    staticClass: "fas fa-star gold"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-faa25e5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/animated-number.vue
// module id = 582
// module chunks = 0